var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJwBlockShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 70,
    y: 50,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(180 70 50)",
    fill: "#004F71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 20,
    y: 70,
    width: 20,
    height: 20,
    rx: 5,
    transform: "rotate(180 20 70)",
    fill: "#004F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwBlockShape);
export default __webpack_public_path__ + "static/media/jwBlockShape.24e4744faf8e54b8e8e60f7116cc52b9.svg";
export { ForwardRef as ReactComponent };